module.exports = "https://r.zoocdn.com/_next/static/images/email-eb28e2a31d81bc2337c890b8d8d0617c.svg";